import { render, staticRenderFns } from "./DocumentManageNumberInputArea.vue?vue&type=template&id=d36b58d8&scoped=true&"
import script from "./DocumentManageNumberInputArea.vue?vue&type=script&lang=ts&"
export * from "./DocumentManageNumberInputArea.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentManageNumberInputArea.vue?vue&type=style&index=0&id=d36b58d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36b58d8",
  null
  
)

export default component.exports